import gql from 'graphql-tag'

export const fetchPlaceOrderMutation = gql`
mutation ($cart_id: String! $empty_return_flag: String!) {
  placeOrder(
        input: {
            cart_id: $cart_id
            empty_return_flag: $empty_return_flag
        }
    )
    {
        order {
            order_number
            customer_order_number
            note_for_driver
            sap_id
        }
    }
}

`
